import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import reduxForm from 'redux-form/es/reduxForm';
import { clearSignUpGate, saveSignUpData } from 'actions/authentication';
import SignupGate from 'components/Credit24/LoanApplication/SignupGate';
import { validate } from 'utils/validation/ee';
import { validateLV } from 'utils/validation/lv';
import { validateFI } from 'utils/validation/fi';

const propTypes = {
  integration: PropTypes.object.isRequired,
  authentication: PropTypes.object.isRequired,
  loan: PropTypes.object.isRequired,
  marketingConsents: PropTypes.array.isRequired,
  intl: PropTypes.object.isRequired,
  saveSignUpData: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  clearSignUpGate: PropTypes.func.isRequired,
};

class SignupGateContainer extends Component {
  constructor() {
    super();
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(data) {
    this.props.saveSignUpData(
      data,
      this.props.integration.partnerID,
      this.props.integration.adtractionChannel,
      this.props.marketingConsents,
      this.props.intl.locale
    );
  }

  render() {
    const {
      authentication,
      handleSubmit,
      integration,
      integration: { partnerID, adtractionChannel },
      marketingConsents,
      loan: { isServiceUnavailable },
    } = this.props;

    let showAdtractionPermission = false;
    const lowerCasePartnerID = partnerID && partnerID.toLowerCase();
    if (EMBEDDED && COUNTRY === 'FI' && lowerCasePartnerID === 'adtraction' && adtractionChannel === '1212940008') {
      showAdtractionPermission = true;
    }

    return (
      <form className="homepage" onSubmit={handleSubmit(this.onSubmit)}>
        <SignupGate
          signUpGateSubmitted={authentication.signUpGateSubmitted}
          showAdtractionPermission={showAdtractionPermission}
          marketingConsents={marketingConsents}
          campaignMessage={integration.campaignMessage}
          isServiceUnavailable={isServiceUnavailable}
          skip={this.props.clearSignUpGate}
          backgroundColor={integration.backgroundColor}
        />
      </form>
    );
  }
}

SignupGateContainer.propTypes = propTypes;

let validateHandler = () => {};

if (COUNTRY === 'LV') {
  validateHandler = validateLV;
} else if (COUNTRY === 'FI') {
  validateHandler = validateFI;
} else if (COUNTRY === 'EE') {
  validateHandler = validate;
}

export default reduxForm({
  form: 'signup-gate-form',
  validate: validateHandler,
  shouldValidate: () => true,
  onSubmitFail: (error) => {
    if (DEBUG) {
      console.warn('form submit fail', error);
    }
  },
})(connect(
  (state) => ({
    authentication: state.authentication,
    loan: state.loan,
    integration: state.integration,
    marketingConsents: state.marketingConsents,
    intl: state.intl,
  }),
  {
    saveSignUpData,
    clearSignUpGate,
  }
)(SignupGateContainer));
